import React, { useEffect, useState } from "react";
import Header from "../header/Header";

function Gaittraining() {
  const [duration, setDuration] = useState(1);
  const [pricePerMonth] = useState(500);

  const handleDurationChange = (amount) => {
    const newDuration = duration + amount;
    if (newDuration > 0) {
      setDuration(newDuration);
    }
  };

  const totalPrice = duration * pricePerMonth;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="bg2">
        <div className="bg3">
          <div style={{ textAlign: "center", position: "relative" }}>
            <img
              src="../style/img/Rehabserv/Gaittraining.jpg"
              className="pneumoban"
              alt="Pneumoban"
            />
           <h3 className="pneu1 text-white" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}>
  <b class="text-white">Gait Training Program</b>
</h3>
<p className="pneu2 text-white" style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)' }}>
  <b class="text-white">
  Reclaim your mobility and confidence
   with our specialized gait training program,
    designed to improve your walking ability and enhance your quality of life.
  </b>
</p>

          </div>
          <br />
          <div className="greenbg">
            <h3
              className="text-center text-white"
              style={{ fontWeight: "bold", fontFamily: "Poppins" }}
            >
              Package Highlights
            </h3>

            <div className="container">
              <div className="row">
                {[
                  {
                    imgSrc: "../style/img/resp/pneuicon2.png",
                    title: "Comprehensive Gait Assessment",
                    description:
                      "Begin with a thorough evaluation by our expert physiotherapists to identify gait abnormalities and tailor a program to address your specific needs.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon2.png",
                    title: "Personalized Gait Training Plan",
                    description:
                      "Receive a customized training regimen focused on your individual challenges, goals, and recovery progress to ensure effective results.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Balance and Coordination Enhancement",
                    description:
                      "Engage in targeted exercises that improve your balance and coordination, vital for safe and stable walking.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Strengthening Key Muscles",
                    description:
                      "Focus on strengthening the muscle groups involved in walking to support better posture and reduce the risk of falls.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Assistive Device Training",
                    description: "Learn how to effectively use walking aids, such as canes or walkers, if necessary, to enhance your mobility and safety.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Functional Mobility Drills",
                    description:
                      "Practice real-life walking scenarios and tasks that mimic daily activities to build confidence and functional independence.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Education on Gait Mechanics",
                    description:
                      "Gain valuable knowledge about proper walking mechanics, posture, and techniques to further enhance your rehabilitation efforts.",
                  },
                  {
                    imgSrc: "../style/img/resp/pneuicon4.png",
                    title: "Ongoing Support and Motivation",
                    description:
                      "Receive continuous encouragement and guidance from our dedicated physiotherapy team, helping you stay motivated throughout your journey to better mobility.",
                  },
                ].map((item, index) => (
                  <div
                    className="col-sm-3 d-flex flex-column align-items-center text-center mb-4" // Added margin-bottom
                    key={index}
                  >
                    <div
                      className="blank d-flex flex-column justify-content-between"
                      style={{ height: "100%" }}
                    >
                      <img
                        src={item.imgSrc}
                        style={{
                          height: "60px",
                          display: "block",
                          margin: "40px auto",
                        }}
                        alt={item.title}
                      />
                      <h5 className="iconh">{item.title}</h5>
                      <p className="iconp">{item.description}</p>
                      <br />
                      <br />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div>
          <center>
            <h3
              style={{
                fontWeight: "800",
                fontFamily: "Poppins",
                fontSize: "30px",
              }}
            >
              Plan Purchase
            </h3>
            <h6
              style={{
                fontSize: "20px",
              }}
            >
              Choose Your Plan Duration
            </h6>
          </center>

          <div class="container">
            <center>
              <div
                class="greenbg priceboxgreen"
                style={{
                  borderRadius: "20px",
                  width: "750px",
                  height: "300px",
                }}
              >
                <br></br>
                <form
                  class="booking-form"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div class="form-group11">
                    <label class="boxresd text-dark">Duration Selector:</label>
                    <div class="diaginput" style={{ position: "relative" }}>
                      <span
                        class="subtraction text-dark"
                        onClick={() => handleDurationChange(-1)}
                        style={{
                          position: "absolute",
                          left: 20,
                          width: "20px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        -
                      </span>
                      <input
                        class="booktestdur"
                        name="duration"
                        value={`${duration} month${duration > 1 ? "s" : ""}`}
                        readOnly
                        style={{
                          textAlign: "center",
                          width: "100%",
                          padding: "0 40px",
                        }}
                      />
                      <span
                        class="addition text-dark  booktestadd"
                        onClick={() => handleDurationChange(1)}
                        style={{
                          position: "absolute",
                          right: 20,
                          bottom: "0px",
                          width: "20px",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        +
                      </span>
                    </div>
                  </div>
                  <div class="form-group11">
                    <label class="boxresd text-dark">Price:</label>
                    <div
                      class="diaginput"
                      style={{ position: "relative", marginLeft: "10px" }}
                    >
                      <input
                        class="booktestdur"
                        style={{ width: "300px" }}
                        type="number"
                        name="totalPrice"
                        value={totalPrice}
                        readOnly
                      />
                    </div>
                  </div>
                </form>
                <br></br>
                <center>
                  <button
                    class="purchasebutton"
                    style={{
                      fontWeight: "600",
                      backgroundColor: "#fff",
                      color: "#466E6C",
                      borderRadius: "30px",
                    }}
                  >
                    Purchase
                  </button>
                </center>
              </div>
            </center>
            <br></br>
          </div>
        </div>
      </div>
    </>
  );
}

export default Gaittraining;
